<template>
  <div>
    <div class="row">
      <div class="col-md-6 mb-2">
        Ativa Telemedicina?
        <toggle-button
          v-model="data.unidade.telemedicina"
          @change="saveUnidade(data.unidade)"
          :width="75"
          :labels="{ checked: 'Ativo', unchecked: 'Inativo' }"
        />
      </div>
      <div class="col-md-6 mb-2">
        <button
          class="btn btn-primary"
          style="float: right; margin-top: -5px"
          data-toggle="modal"
          data-target="#modalNovaPergunta"
        >
          Nova Pergunta
        </button>
      </div>
    </div>
    <div
      class="row"
      v-if="data.telemedicina.length > 0 && !data.unidade.telemedicina"
    >
      <div class="col-md-12">
        <div class="alert alert-danger p-1" role="alert">
          Erro! Com a telemedicina desabilitada, você precisa inativar todas as
          perguntas do grupo "Telemedicina"
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Pesquisa Presencial</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="d-flex justify-content-end mb-2">
                  <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="isSaving"
                    @click="savePerguntas"
                  >
                    Salvar todas
                    <span v-if="!isSaving"></span>
                    <span v-else>Salvando...</span>
                  </button>
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Ordem</th>
                      <th scope="col">Texto</th>
                      <th scope="col">Tipo Resposta</th>
                      <th scope="col">Identificador</th>
                      <th scope="col">Aciona Identificador</th>
                      <th scope="col">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(pergunta, index) in data.presencial"
                      :key="pergunta.pesquisa_id"
                    >
                      <th scope="row" style="width: 10%">
                        <input
                          type="number"
                          class="form-control"
                          v-model="pergunta.ordem"
                        />
                      </th>
                      <td style="width: 50%">
                        <input
                          type="text"
                          class="form-control"
                          v-model="pergunta.texto"
                        />
                      </td>
                      <td style="width: 10%">{{ pergunta.tipo_resposta }}</td>
                      <td style="width: 10%">
                        <input
                          type="number"
                          class="form-control"
                          v-model="pergunta.identificador"
                        />
                      </td>
                      <td style="width: 10%">
                        <input
                          :disabled="
                            !(
                              pergunta.tipo_resposta == 'D' ||
                              pergunta.tipo_resposta == 'DT'
                            )
                          "
                          type="number"
                          class="form-control"
                          v-model="pergunta.aciona_identificador"
                        />
                      </td>
                      <td style="width: 20%">
                        <button
                          class="btn btn-crud edit"
                          @click="getRespostas(pergunta, index)"
                        >
                          <i class="fas fa-reply"></i>
                        </button>
                        <button
                          class="btn btn-crud info"
                          @click="savePergunta(pergunta)"
                        >
                          <i class="fas fa-save"></i>
                        </button>
                        <button
                          class="btn btn-crud delete"
                          @click="inativaPergunta(pergunta)"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="data.presencial.length == 0">
                      <td colspan="5" align="center">
                        Nenhuma pergunta neste grupo
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Pesquisa Telemedicina</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Ordem</th>
                      <th scope="col">Texto</th>
                      <th scope="col">Tipo Resposta</th>
                      <th scope="col">Identificador</th>
                      <th scope="col">Aciona Identificador</th>
                      <th scope="col">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="pergunta in data.telemedicina"
                      :key="pergunta.pesquisa_id"
                    >
                      <th scope="row" style="width: 10%">
                        <input
                          type="number"
                          class="form-control"
                          v-model="pergunta.ordem"
                        />
                      </th>
                      <td style="width: 50%">
                        <input
                          type="text"
                          class="form-control"
                          v-model="pergunta.texto"
                        />
                      </td>
                      <td style="width: 10%">{{ pergunta.tipo_resposta }}</td>
                      <td style="width: 10%">
                        <input
                          type="number"
                          class="form-control"
                          v-model="pergunta.identificador"
                        />
                      </td>
                      <td style="width: 10%">
                        <input
                          :disabled="
                            !(
                              pergunta.tipo_resposta == 'D' ||
                              pergunta.tipo_resposta == 'DT'
                            )
                          "
                          type="number"
                          class="form-control"
                          v-model="pergunta.aciona_identificador"
                        />
                      </td>
                      <td style="width: 20%">
                        <button
                          class="btn btn-crud edit"
                          @click="getRespostas(pergunta)"
                        >
                          <i class="fas fa-reply"></i>
                        </button>
                        <button
                          class="btn btn-crud info"
                          @click="savePergunta(pergunta)"
                        >
                          <i class="fas fa-save"></i>
                        </button>
                        <button
                          class="btn btn-crud delete"
                          @click="inativaPergunta(pergunta)"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="data.telemedicina.length == 0">
                      <td colspan="5" align="center">
                        Nenhuma pergunta neste grupo
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de respostas -->
    <div
      class="modal fade"
      id="modalRespostas"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalRespostasTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ perguntaSelecionada.texto }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section v-if="section == 1">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <button
                    class="btn btn-primary"
                    style="float: right; margin-top: -5px"
                    data-toggle="modal"
                    data-target="#modalNovaResposta"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    Nova Resposta
                  </button>
                </div>
                <div class="col-md-12">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Ordem</th>
                        <th scope="col">Texto</th>
                        <th scope="col">Aciona Identificador</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="resposta in respostas"
                        :key="resposta.resposta_id"
                      >
                        <th scope="row" style="width: 5%">
                          <input
                            type="number"
                            class="form-control"
                            v-model="resposta.ordem"
                          />
                        </th>
                        <td style="width: 45%">
                          <input
                            type="text"
                            class="form-control"
                            v-model="resposta.texto"
                          />
                        </td>
                        <td style="width: 50%">
                          <v-select
                            :options="data.presencial"
                            :label="'texto'"
                            :reduce="(data) => data.identificador"
                            v-model="resposta.aciona_identificador"
                          ></v-select>
                        </td>
                        <td style="width: 10%">
                          <button
                            class="btn btn-crud info"
                            type="button"
                            @click="saveResposta(resposta)"
                          >
                            <i class="fas fa-save"></i>
                          </button>
                          <button
                            class="btn btn-crud delete"
                            type="button"
                            @click="inativaResposta(resposta)"
                          >
                            <i class="fas fa-times"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="respostas.length == 0" align="center">
                        <td colspan="4">
                          Nenhuma resposta vinculada a esta pergunta.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
            <section v-if="section == 2">
              <div class="row"><div class="col-md-2"></div></div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de nova pergunta -->
    <div
      class="modal fade"
      id="modalNovaPergunta"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalNovaPerguntaTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Nova pergunta
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label>Identificador</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="new_pergunta.identificador"
                />
              </div>
              <div class="col-md-5">
                <label>Grupo de Pesquisa</label>
                <select
                  class="form-control"
                  v-model="new_pergunta.grupo_pesquisa_id"
                >
                  <option value="" selected>Selecione...</option>
                  <option value="1">Presencial</option>
                  <option value="2">Telemedicina</option>
                </select>
              </div>
              <div class="col-md-3">
                <label>Obrigatório</label>
                <select class="form-control" v-model="new_pergunta.obrigatorio">
                  <option value="" selected>Selecione...</option>
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </select>
              </div>
              <div class="col-md-12 mt-1">
                <label>Texto</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_pergunta.texto"
                />
              </div>
              <div class="col-md-4 mt-1">
                <label>Tipo da pergunta</label>
                <select
                  class="form-control"
                  v-model="new_pergunta.tipo_resposta"
                >
                  <option value="" selected>Selecione...</option>
                  <option value="D">Dissertativa</option>
                  <option value="A">Alternativa</option>
                  <option value="T">Texto simples</option>
                  <option value="DT">Data</option>
                </select>
              </div>
              <div class="col-md-4 mt-1">
                <label>Ordem</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="new_pergunta.ordem"
                />
              </div>
              <div
                class="col-md-12 mt-1"
                v-if="
                  new_pergunta.grupo_pesquisa_id == 1 &&
                  new_pergunta.tipo_resposta == 'D'
                "
              >
                <label>Aciona identificador</label>
                <v-select
                  :options="data.presencial"
                  :label="'texto'"
                  :reduce="(data) => data.identificador"
                  v-model="new_pergunta.aciona_identificador"
                ></v-select>
              </div>
              <div
                class="col-md-12 mt-1"
                v-if="
                  new_pergunta.grupo_pesquisa_id == 2 &&
                  new_pergunta.tipo_resposta == 'D'
                "
              >
                <label>Aciona identificador</label>
                <v-select
                  :options="data.telemedicina"
                  :label="'texto'"
                  :reduce="(data) => data.identificador"
                  v-model="new_pergunta.aciona_identificador"
                ></v-select>
              </div>
              <div
                class="col-md-12 mt-1"
                v-if="new_pergunta.tipo_resposta == 'A'"
              >
                <div class="alert alert-danger p-1" role="alert">
                  Atenção! Primeiro salve a pergunta, na sequência edite para
                  incluir as respostas
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="novaPergunta">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de nova resposta -->
    <div
      class="modal fade"
      id="modalNovaResposta"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalNovaRespostaTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Nova resposta
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 mt-1">
                <label>Texto</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_resposta.texto"
                />
              </div>
              <div class="col-md-4 mt-1">
                <label>Tipo da resposta</label>
                <select class="form-control" v-model="new_resposta.label">
                  <option value="" selected>Selecione...</option>
                  <option value="T">Texto</option>
                  <option value="TI">Texto com Imagem</option>
                  <option value="I">Imagem</option>
                </select>
              </div>
              <div class="col-md-4 mt-1">
                <label>Ordem</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="new_resposta.ordem"
                />
              </div>

              <div
                class="col-md-6 mt-1"
                v-if="new_resposta.label == 'I' || new_resposta.label == 'TI'"
              >
                <label>Label de imagem</label>
                <v-select
                  :options="images"
                  label="label"
                  :reduce="(option) => option.value"
                  v-model="new_resposta.label_image_path"
                  style="z-index: 99999999999999999 !important"
                >
                  <!-- Slot para customizar como as opções aparecem -->
                  <template #option="option">
                    <div class="option-content">
                      <img :src="'/' + option.label" alt="Imagem" height="60" />
                    </div>
                  </template>

                  <!-- Slot para customizar o valor selecionado -->
                  <template #selected-option="option">
                    <div class="option-content">
                      <img :src="'/' + option.label" alt="Imagem" height="60" />
                    </div>
                  </template>
                </v-select>
              </div>
              <div
                class="col-md-12 mt-1"
                v-if="perguntaSelecionada.grupo_pesquisa_id == 1"
              >
                <label>Aciona identificador</label>
                <v-select
                  :options="data.presencial"
                  :label="'texto'"
                  :reduce="(data) => data.identificador"
                  v-model="new_resposta.aciona_identificador"
                ></v-select>
              </div>
              <div
                class="col-md-12 mt-1"
                v-if="perguntaSelecionada.grupo_pesquisa_id == 2"
              >
                <label>Aciona identificador</label>
                <v-select
                  :options="data.telemedicina"
                  :label="'texto'"
                  :reduce="(data) => data.identificador"
                  v-model="new_resposta.aciona_identificador"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="novaResposta">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      isSaving: false,
      unidade_id: null,
      section: 1,
      unidade: {},
      index_pergunta: null,
      new_pergunta: {},
      new_resposta: {
        label_image_path: null,
        texto: null,
        ordem: null,
        aciona_identificador: null,
      },
      filters: {},
      respostas: [],
      perguntaSelecionada: {
        grupo_pesquisa_id: null,
      },
      data: {
        presencial: [],
        telemedicina: [],
      },
      images: [
        { label: "damasco/nps/0.png", value: "damasco/nps/0.png" },
        { label: "damasco/nps/1.png", value: "damasco/nps/1.png" },
        { label: "damasco/nps/2.png", value: "damasco/nps/2.png" },
        { label: "damasco/nps/3.png", value: "damasco/nps/3.png" },
        { label: "damasco/nps/4.png", value: "damasco/nps/4.png" },
        { label: "damasco/nps/5.png", value: "damasco/nps/5.png" },
        { label: "damasco/nps/6.png", value: "damasco/nps/6.png" },
        { label: "damasco/nps/7.png", value: "damasco/nps/7.png" },
        { label: "damasco/nps/8.png", value: "damasco/nps/8.png" },
        { label: "damasco/nps/9.png", value: "damasco/nps/9.png" },
        { label: "damasco/nps/10.png", value: "damasco/nps/10.png" },
        //Outros
        {
          label: "damasco/alternativas/colorido/0.png",
          value: "damasco/alternativas/colorido/0.png",
        },
        {
          label: "damasco/alternativas/colorido/1.png",
          value: "damasco/alternativas/colorido/1.png",
        },
        {
          label: "damasco/alternativas/colorido/2.png",
          value: "damasco/alternativas/colorido/2.png",
        },
        {
          label: "damasco/alternativas/colorido/3.png",
          value: "damasco/alternativas/colorido/3.png",
        },
        {
          label: "damasco/alternativas/colorido/4.png",
          value: "damasco/alternativas/colorido/4.png",
        },
      ],
    };
  },
  components: {},
  methods: {
    savePerguntas() {
      const self = this;
      const api = self.$store.state.api + "save-perguntas";

      const perguntas = self.data.presencial.map((p) => ({
        pesquisa_id: p.pesquisa_id,
        ordem: Number(p.ordem),
        texto: p.texto,
      }));

      axios
        .post(api, { perguntas })
        .then(() => {
          self.$message(null, "Perguntas atualizadas com sucesso", "success");
          // use o unidade_id guardado
          self.getEntity(self.unidade_id);
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.message || "Erro ao salvar perguntas";
          self.$message(null, msg, "error");
        });
    },
    saveUnidade(data) {
      const self = this;
      const api = self.$store.state.api + "save-unidade";

      axios
        .post(api, data)
        .then((response) => {
          self.getEntity(data.unidade_id);
          self.$message(null, "Unidade atualizada com sucesso", "success");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    inativaPergunta(data) {
      const self = this;
      const api = self.$store.state.api + "save-pergunta";
      swal({
        title: "Deseja inativar a pergunta?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi inativado!", "info");
            break;
          case "confirm":
            data.ativo = 0;

            axios
              .post(api, data)
              .then((response) => {
                self.getEntity(data.unidade_id);
                self.$message(
                  null,
                  "Pergunta inativada com sucesso",
                  "success",
                );
                self.new_pergunta = {};
              })
              .catch((error) => {
                self.$message(null, error.response.data, "error");
              });
            break;
        }
      });
    },
    inativaResposta(data) {
      const self = this;
      const api = self.$store.state.api + "save-resposta";
      swal({
        title: "Deseja inativar a pergunta?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi inativado!", "info");
            break;
          case "confirm":
            data.ativo = 0;

            axios
              .post(api, data)
              .then((response) => {
                self.getEntity(data.unidade_id);
                self.$message(
                  null,
                  "Resposta inativada com sucesso",
                  "success",
                );
                setTimeout(() => {
                  $("#modalRespostas").modal("hide");
                }, 500);
              })
              .catch((error) => {
                self.$message(null, error.response.data, "error");
              });
            break;
        }
      });
    },

    savePergunta(data) {
      const self = this;
      const api = self.$store.state.api + "save-pergunta";

      axios
        .post(api, data)
        .then((response) => {
          self.getEntity(data.unidade_id);
          self.$message(null, "Pergunta atualizada com sucesso", "success");
          self.new_pergunta = {};
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    novaPergunta() {
      const self = this;
      const api = self.$store.state.api + "nova-pergunta";

      self.new_pergunta.ativo = 1;
      self.new_pergunta.deleted = 0;
      self.new_pergunta.grupo_pergunta_id = 0;
      self.new_pergunta.unidade_id = self.$route.params.id;

      axios
        .post(api, self.new_pergunta)
        .then((response) => {
          self.getEntity(self.$route.params.id);
          self.$message(null, "Pergunta incluída com sucesso", "success");
          setTimeout(() => {
            $("#modalNovaPergunta").modal("hide");
          }, 500);
          self.new_pergunta = {};
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    novaResposta() {
      const self = this;
      const api = self.$store.state.api + "nova-resposta";

      self.new_resposta.ativo = 1;
      self.new_resposta.deleted = 0;
      self.new_resposta.unidade_id = self.$route.params.id;
      self.new_resposta.pesquisa_id = self.perguntaSelecionada.pesquisa_id;

      axios
        .post(api, self.new_resposta)
        .then((response) => {
          self.getEntity(self.$route.params.id);
          self.new_resposta = {};
          self.$message(null, "Resposta incluída com sucesso", "success");
          self.getRespostas(self.perguntaSelecionada, self.index_pergunta);
          setTimeout(() => {
            $("#modalNovaResposta").modal("hide");
            $("#modalRespostas").modal("show");
          }, 500);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveResposta(data) {
      const self = this;
      const api = self.$store.state.api + "save-resposta";

      axios
        .post(api, data)
        .then((response) => {
          self.getEntity(data.unidade_id);
          self.$message(null, "Resposta atualizada com sucesso", "success");
          setTimeout(() => {
            // $("#modalRespostas").modal("hide");
          }, 500);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRespostas(data, index) {
      const self = this;
      const api = self.$store.state.api + "get-respostas";

      if (data.tipo_resposta == "D" || data.tipo_resposta == "DT") {
        self.$message(
          null,
          "Pergunta dissertativa ou de data, não possui respostas",
          "error",
        );
        return;
      }

      self.perguntaSelecionada = data;
      self.index_pergunta = index;

      axios
        .post(api, { pesquisa_id: data.pesquisa_id })
        .then((response) => {
          self.respostas = response.data;
          setTimeout(() => {
            $("#modalRespostas").modal("show");
          }, 500);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity(id) {
      const self = this;
      const api = self.$store.state.api + "get-pesquisa";

      // Se não passar id, use o último conhecido
      const unidade = id ?? self.unidade_id;
      if (!unidade) {
        self.$message(null, "Unidade não informada.", "error");
        return;
      }

      // Salva o id atual para reuso futuro
      self.unidade_id = unidade;

      axios
        .post(api, { unidade_id: unidade })
        .then((response) => {
          self.data = response.data;

          if (self.index_pergunta != null && self.data.presencial?.length) {
            self.perguntaSelecionada =
              self.data.presencial[self.index_pergunta];
          }
        })
        .catch((error) => {
          self.$message(
            null,
            error.response?.data || "Erro ao carregar",
            "error",
          );
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;

    if (id) {
      self.getEntity(id);
    }
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
